import React from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Modal from 'components/Luxkit/Modal/Modal'

function RefreshSearchModal() {
  return (
    <Modal
      title="Your search session has expired"
      primaryActionText="Refresh"
      onPrimaryActionClick={() => window.location.reload()}
    >
      <BodyText variant="large">
        Refresh your search to see available offers.
      </BodyText>
    </Modal>
  )
}

export default RefreshSearchModal
